<template>
  <Section gap="2rem">
    <div class="width-50rem margin-auto text-line-relaxed">
      <slot />
    </div>
    <!-- <NavArticles /> -->
  </Section>
</template>

<script setup>
defineOptions({ name: "C_Article" });

import Section from "./Section.vue";
// import NavArticles from "../components/NavArticles.vue";
</script>
